export default __webpack_public_path__ + "static/media/Line.7f27f956.svg";